import { NavLink } from "react-router-dom";

const menuList = [
  { label: "Dashboard", icon: "dashboard-2-line", path: "/" },
  { label: "Leads", icon: "contacts-book-2-line", path: "/leads" },
  { label: "Calls", icon: "phone-line", path: "/zoom-calls" },
  { label: "Pipeline", icon: "bar-chart-box-line", path: "/pipeline" },
  { label: "Matters", icon: "file-chart-line", path: "/matters" },
  { label: "Teams", icon: "team-line", path: "/teams", role: 1 },
  { label: "Calendar", icon: "calendar-2-line", path: "/calendar" },
  { label: "Contacts", icon: "contacts-book-3-line", path: "/contacts" },
  { label: "Settings", icon: "settings-3-line", path: "/settings" },
];

const Sidebar = ({ onLogout }) => {
  const onToogleMenu = () => {
    const element = document.getElementById("toogleBoby");
    element.classList.toggle("sidebar-enable");
    element.setAttribute("data-menu-size", element.classList.contains("sidebar-enable") ? "condensed" : "default");
  };

  return (
    <div className="main-nav">
      <button type="button" className="button-toggle-menu topbar-button" onClick={onToogleMenu}>
        <i className="ri-menu-2-line fs-24"></i>
      </button>

      <div className="scrollbar">
        <ul className="navbar-nav" id="navbar-nav">
          {menuList.map((item, idx) => (
            <li key={item.path} className="nav-item fadeUp" style={{ animationDelay: `${0.1 * (idx + 1)}s` }}>
              <NavLink
                to={item.path}
                end={item.path === "/"} // exact for root
                className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
              >
                <span className="nav-icon">
                  <i className={`ri-${item.icon}`}></i>
                </span>
                <span className="nav-text">{item.label}</span>
              </NavLink>
            </li>
          ))}

          <li className="nav-item fadeUp" style={{ animationDelay: `${0.1 * (menuList.length + 1)}s` }}>
            <button className="nav-link" type="button" onClick={onLogout}>
              <span className="nav-icon">
                <i className="ri-logout-box-line"></i>
              </span>
              <span className="nav-text">Logout</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
